import React from 'react';
import PropTypes from 'prop-types';

import 'flag-icon-css/css/flag-icon.css';

const Span = ({ className }) => {
  return (
    <span
      style={{ fontSize: 20, cursor: 'pointer' }}
      className={`flag-icon ${className}`}
    />
  );
};

Span.propTypes = {
  className: PropTypes.string.isRequired,
};

export const FrenchFlag = () => <Span className="flag-icon-fr" />;

export const EnglishFlag = () => <Span className="flag-icon-gb" />;



// WEBPACK FOOTER //
// ./src/components/Header/FlagIcon.js